export class EmployementVerificationModel {
    CompanyName: string;
    Address1: string;
    City: string;
    State: string;
    StartDate: any;
    EndDate: any;
    CurrentlytWorkHere: boolean;
    ApplicantName: string;
    Position: string;
    ReasonForLeaving: string;
    ContactName: string;
    PhoneNumber: any;
    EmailAddress: string;
    OrderId: string;
    Status = 'New';
    ReviewMode = false;
    ServiceMasterId: number;
    id: string;
    FullDateOfJoining: string;
    EmployerName: string;
    EntryInWhichCase: string;
    EditMobileNumber: string;
    ContactCheck: string;
    StreetNumber: string;
    StreetAddress: string;
    UserEmail: string;
}
